import React, {useState} from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames/bind';
import {useSearchParams} from 'react-router-dom';
import {connect} from 'react-redux';
import _ from 'lodash';
import FindTheRightOil from '../NewUI/FindTheRightOil';
import HeaderTemplate from '../NewUI/HeaderTemplate';
import {useAppName} from '../../hooks/use-app-names';
import {
  APPNAME,
  FASTSCAN,
  ONLYWTBCOUNTRIES
} from '../../constants';
import { Variant } from '../../constants/variants';
import {IProd, IState, Replacement} from '../../interface';
import {PageType} from '../../interface/emnu';
import style from './index.module.scss';
import Loading from '../Loading';
import WhereToBuy from '../NewUI/WhereToBuy';
import Product from '../NewUI/Product';
import ProductInformation from '../NewUI/ProductInformation';
import Landing from '../NewUI/Landing';
import Footer from '../NewUI/Footer';
import ArrowUp from '../../images/bp-arrow-collapse-bp-light-green.svg';
import ArrowDown from '../../images/bp-arrow-expand-bp-light-green.svg';

import ExternalLink from '../NewUI/ExternalLink';

const cx = classnames.bind(style);

export interface Props {
  replacements: Replacement;
}

function Layout(props: Props) {
  const {replacements} = props;
  const [params] = useSearchParams();
  const page = params.get('page');

  const variant = params.get('variant');
  const isFord = variant == Variant.FORD;

  const isWider = ['recommendedProducts', 'wheretobuy', 'product'].includes(page ?? '');

  const results = useSelector((state: any) => state.results);
  const countryObject = useSelector((state: any) => state.country);
  const country = countryObject.isoCode || localStorage.getItem('countryCode')  || process.env.REACT_APP_COUNTRYCODE as string;
  const i18n = useSelector((state: any) => state.lang) || localStorage.getItem('languageCode') || process.env.REACT_APP_LANGUAGECODE  as string;

  const [searchParams, setSearchParams] = useSearchParams();
  const [product, setProduct] = useState<IProd>();
  const [ collapsed, setCollapsed ] = useState<boolean>(false);
  const [mode, setMode] = useState<boolean>(
    sessionStorage.getItem('selectedType') === 'true' ? true : false,
  );
  const isFastScan = useAppName(FASTSCAN);

  const onWTBClick = () => {

    searchParams.set('page', 'wheretobuy');
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
  };
  const onVehicleSelect = (value: string | number, model?: string) => {
    searchParams.set('page', 'recommendedProducts');
    searchParams.set('id', _.toString(value));
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
  };
  const onProductSelect = (value: string | number, product?: string) => {
    searchParams.set('page', 'product');
    searchParams.set('id', _.toString(value));
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
  };

  let pageName: string;
  let component: JSX.Element = <Loading />;
  switch (page) {
    case 'wheretobuy':
      pageName = 'wtb';
      component = <WhereToBuy />;
      break;
    case 'recommendedProducts':
      pageName = 'recommended';
      component = <Product trade={mode} setTrade={setMode} />;
      break;
    case 'product':
      pageName = 'product';
      component = (
        <ProductInformation productHandler={setProduct} trade={mode} setTrade={setMode} />
      );
      break;
    default:
      pageName = 'landing';
      component = <Landing onProductSelect={onProductSelect} />;
      break;
  }

  return (
    <div className={`new-ui ${cx(pageName, {trade: mode})}`}>
      <div className={cx('container')}>
        <HeaderTemplate mode={mode} product={product} />
        <div className={`${cx('main-content')}`}>
          <div className={cx('collapse')} onClick={() => setCollapsed(!collapsed)}>
            <img src={collapsed ? ArrowDown : ArrowUp}/>
          </div>
          {!ONLYWTBCOUNTRIES.includes(country) && (
              <div className={results || isWider ? !collapsed ? cx('sider') : cx('sider-hidden') : !collapsed ? cx('sider-wide') : cx('sider-hidden')}>
                <div className={cx('flyout')}>
                  <FindTheRightOil
                    country={country}
                    onVehicleSelect={onVehicleSelect}
                    onProductSelect={onProductSelect}
                    onWTBClick={onWTBClick}
                    i18n={i18n}
                    locales={replacements}
                    baseAPI={process.env.REACT_APP_PROVIDER_URL}
                    restore={isFastScan}
                    mode={mode}
                    setMode={setMode}
                  />
                </div>
              </div>              
            )
          }
          <div className={cx('content')}>{component}</div>
        </div>
        <ExternalLink />
        { isFord && (
          <div className={cx('footer')}>
            <Footer
              replacements={replacements}
              country={country} />
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
});

export default connect(mapStateToProps)(Layout);
